import { render, staticRenderFns } from "./SystemModuleView.vue?vue&type=template&id=bc4a52da&scoped=true"
import script from "./SystemModuleView.vue?vue&type=script&lang=js"
export * from "./SystemModuleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4a52da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc4a52da')) {
      api.createRecord('bc4a52da', component.options)
    } else {
      api.reload('bc4a52da', component.options)
    }
    module.hot.accept("./SystemModuleView.vue?vue&type=template&id=bc4a52da&scoped=true", function () {
      api.rerender('bc4a52da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/systemmodule/SystemModuleView.vue"
export default component.exports